export const banners = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=professional%20massage%20therapist%20doing%20back%20massage%20in%20cozy%20home%20setting%2C%20warm%20lighting%2C%20candles%2C%20clean%20white%20linen%2C%20relaxing%20atmosphere%2C%20high%20end%20spa%20ambiance%2C%20golden%20tones%2C%20soft%20focus%20background&width=750&height=340&seq=b001&orientation=landscape",
    title: "\u4e13\u4e1a\u4e0a\u95e8\u6309\u6469",
    subtitle: "\u8db3\u4e0d\u51fa\u6237\u4eab\u53d7\u4e94\u661f\u7ea7SPA\u4f53\u9a8c",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=serene%20spa%20massage%20room%20with%20aromatherapy%20candles%2C%20bamboo%20decoration%2C%20soft%20towels%2C%20essential%20oils%2C%20tranquil%20zen%20style%20interior%2C%20warm%20amber%20lighting%2C%20minimal%20clean%20aesthetic&width=750&height=340&seq=b002&orientation=landscape",
    title: "\u65b0\u5ba2\u4e13\u4eab\u4f18\u60e0",
    subtitle: "\u9996\u5355\u7acb\u51cf60\u5143\uff0c\u4eca\u65e5\u9884\u7ea69\u62989\u6298",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=luxury%20home%20massage%20service%2C%20professional%20therapist%20with%20client%2C%20relaxing%20bedroom%20setting%2C%20herbal%20compress%20therapy%2C%20warm%20neutral%20tones%2C%20high%20quality%20lifestyle%20photography&width=750&height=340&seq=b003&orientation=landscape",
    title: "\u8d44\u6df1\u6280\u5e08\u8ba4\u8bc1",
    subtitle: "100+\u5c0f\u65f6\u57f9\u8bad\uff0c\u6301\u8bc1\u4e0a\u5c97\u6709\u4fdd\u969c",
  },
];

export const services = [
  {
    id: 1,
    icon: "ri-body-scan-line",
    name: "\u5168\u8eab\u653e\u677e",
    duration: "90min",
    price: 298,
    originalPrice: 398,
    tag: "\u70ed\u95e8",
    image: "https://readdy.ai/api/search-image?query=full%20body%20relaxation%20massage%20professional%20spa%20treatment%2C%20warm%20lighting%2C%20clean%20white%20towels%2C%20essential%20oils%2C%20serene%20atmosphere%2C%20minimal%20background&width=400&height=300&seq=s001&orientation=landscape",
    description: "\u758f\u901a\u5168\u8eab\u7ecf\u7edc\uff0c\u7f13\u89e3\u808c\u8089\u7d27\u5f20\uff0c\u6df1\u5ea6\u653e\u677e\u51cf\u538b",
  },
  {
    id: 2,
    icon: "ri-heart-pulse-line",
    name: "\u7cbe\u6cb9SPA",
    duration: "120min",
    price: 398,
    originalPrice: 498,
    tag: "\u63a8\u8350",
    image: "https://readdy.ai/api/search-image?query=aromatherapy%20essential%20oil%20spa%20massage%2C%20luxury%20treatment%2C%20rose%20petals%2C%20amber%20oil%20bottles%2C%20white%20linen%2C%20soft%20candle%20glow%2C%20elegant%20spa%20setting&width=400&height=300&seq=s002&orientation=landscape",
    description: "\u8fdb\u53e3\u7cbe\u6cb9\u914d\u65b9\uff0c\u6df1\u5c42\u6ecb\u517b\u808c\u80a4\uff0c\u8212\u7f13\u7126\u8651\u60c5\u7eea",
  },
  {
    id: 3,
    icon: "ri-medal-line",
    name: "\u4e2d\u533b\u63a8\u62ff",
    duration: "60min",
    price: 188,
    originalPrice: 258,
    tag: "\u7ecf\u5178",
    image: "https://readdy.ai/api/search-image?query=traditional%20chinese%20medicine%20tuina%20massage%2C%20professional%20therapist%20hands%2C%20acupressure%20points%2C%20warm%20clinic%20setting%2C%20wooden%20background%2C%20herbal%20elements&width=400&height=300&seq=s003&orientation=landscape",
    description: "\u4f20\u7edf\u624b\u6cd5\u7ed3\u5408\u73b0\u4ee3\u7406\u75597\uff0c\u9488\u5bf9\u9888\u80a9\u8170\u80cc\u75db\u6548\u679c\u663e\u8457",
  },
  {
    id: 4,
    icon: "ri-footprint-line",
    name: "\u8db3\u90e8\u7406\u7597",
    duration: "60min",
    price: 128,
    originalPrice: 168,
    tag: "\u7279\u60e0",
    image: "https://readdy.ai/api/search-image?query=foot%20reflexology%20therapy%20massage%2C%20professional%20foot%20care%2C%20warm%20water%20basin%2C%20relaxing%20spa%20environment%2C%20clean%20white%20towels%2C%20natural%20light&width=400&height=300&seq=s004&orientation=landscape",
    description: "\u7a74\u4f4d\u6309\u538b\u523a\u6fc0\u53cd\u5c04\u533a\uff0c\u4fc3\u8fdb\u8840\u6db2\u5faa\u73af\uff0c\u6d88\u9664\u75b2\u52b3",
  },
  {
    id: 5,
    icon: "ri-leaf-line",
    name: "\u9888\u80a9\u653e\u677e",
    duration: "45min",
    price: 138,
    originalPrice: 178,
    tag: "",
    image: "https://readdy.ai/api/search-image?query=neck%20and%20shoulder%20massage%20therapy%2C%20office%20worker%20relaxation%2C%20professional%20hands%20technique%2C%20soft%20lighting%2C%20clean%20minimal%20spa%20setting&width=400&height=300&seq=s005&orientation=landscape",
    description: "\u4e13\u4e3a\u4e45\u5750\u65cf\u8bbe\u8ba1\uff0c\u5feb\u901f\u89e3\u51b3\u9888\u690e\u50f5\u786c\u95ee\u9898",
  },
  {
    id: 6,
    icon: "ri-parent-line",
    name: "\u5b55\u671f\u8212\u7f13",
    duration: "60min",
    price: 268,
    originalPrice: 318,
    tag: "",
    image: "https://readdy.ai/api/search-image?query=prenatal%20pregnancy%20massage%20gentle%20therapy%2C%20caring%20professional%20service%2C%20soft%20warm%20lighting%2C%20comfortable%20setting%2C%20natural%20tones%2C%20relaxing%20atmosphere&width=400&height=300&seq=s006&orientation=landscape",
    description: "\u4e13\u4e1a\u5b55\u671f\u624b\u6cd5\uff0c\u5b89\u5168\u8212\u7f13\u8170\u80cc\u4e0d\u9002\uff0c\u6bcd\u5a34\u5747\u5b89",
  },
];

export const therapistList = [
  {
    id: 1,
    name: "\u6797\u6653\u8587",
    level: "\u9ad8\u7ea7" as const,
    levelStyle: { color: "#C8860A", bg: "#FFF8E7", border: "#FFD980" },
    status: "\u53ef\u670d\u52a1",
    statusStyle: { color: "#17B978", bg: "#E8FBF3" },
    rating: 4.9,
    orders: 1280,
    earliestTime: "16:00",
    distance: "1.58km",
    favorited: true,
    favorites: 320,
    specialties: ["\u5168\u8eab\u653e\u677e", "\u7cbe\u6cb9SPA", "\u4e2d\u533b\u63a8\u62ff"],
    intro: "\u4e13\u4e1a\u56fd\u5bb6\u4e2d\u533b\u63a8\u62ff\u8d44\u683c\u8ba4\u8bc1\uff0c\u64c5\u957f\u8212\u7f13\u9888\u80a9\u8170\u80cc\u75db\u53ca\u5168\u8eab\u653e\u677e\uff0c8\u5e74\u4e30\u5bcc\u7ecf\u9a8c\u6df1\u53d7\u5ba2\u6237\u597d\u8bc4\u3002",
    location: "\u6df1\u5733\u5e02 \u00b7 175m",
    age: "90\u540e",
    years: "\u4ece\u4e1a8\u5e74",
    tags: ["\u6e29\u67d4\u7ec6\u81f4", "\u624b\u6cd5\u4e13\u4e1a", "\u6c9f\u901a\u987a\u7545", "\u8d85\u51fa\u671f\u671b", "\u5f3a\u70c8\u63a8\u8350"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/78c805eb-2a27-46dc-9891-f2f0576571cc_01-3.png?v=29e49e33514a0eef7ddac149aca632b5",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
    lifePhotos: [
      "https://readdy.ai/api/search-image?query=young%20asian%20female%20therapist%20casual%20lifestyle%20portrait%20outdoor%20natural%20light%20warm%20smile%20candid%20photo%20relaxed%20happy%20park&width=400&height=560&seq=lf_101&orientation=portrait",
      "https://readdy.ai/api/search-image?query=young%20asian%20woman%20casual%20daily%20life%20coffee%20shop%20reading%20book%20natural%20light%20warm%20tone%20lifestyle%20candid&width=400&height=560&seq=lf_103&orientation=portrait",
    ],
    photos: [
      "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/78c805eb-2a27-46dc-9891-f2f0576571cc_01-3.png?v=29e49e33514a0eef7ddac149aca632b5",
      "https://readdy.ai/api/search-image?query=asian%20female%20massage%20therapist%20working%20professional%20indoor%20spa%20treatment%20room%20lifestyle%20photo&width=400&height=560&seq=lf_102&orientation=portrait",
    ],
  },
  {
    id: 2,
    name: "\u4f55\u5029",
    level: "\u4e2d\u7ea7" as const,
    levelStyle: { color: "#8B6FE8", bg: "#F2EEFF", border: "#C9BCFF" },
    status: "\u670d\u52a1\u4e2d",
    statusStyle: { color: "#FF7B22", bg: "#FFF3EC" },
    rating: 4.8,
    orders: 986,
    earliestTime: "18:00",
    distance: "2.10km",
    favorited: false,
    favorites: 256,
    specialties: ["\u4e2d\u533b\u63a8\u62ff", "\u9888\u80a9\u653e\u677e"],
    intro: "\u6bd5\u4e1a\u4e8e\u4e2d\u533b\u836f\u5927\u5b66\uff0c\u6301\u6709\u591a\u9879\u4e13\u4e1a\u8bc1\u4e66\uff0c\u64c5\u957f\u8fd0\u7528\u4f20\u7edf\u63a8\u62ff\u624b\u6cd5\u7ed3\u5408\u73b0\u4ee3\u7406\u7597\u6280\u672f\u3002",
    location: "\u6df1\u5733\u5e02 \u00b7 210m",
    age: "95\u540e",
    years: "\u4ece\u4e1a6\u5e74",
    tags: ["\u529b\u9053\u7cbe\u51c6", "\u8010\u5fc3\u8d1f\u8d23", "\u51c6\u65f6\u5b88\u7ea6", "\u7269\u8d85\u6240\u503c"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/4da58105-9f88-415f-a957-a7acb99f227e_02-.png?v=3e77774350a88cc7d3f737789eac33e6",
    video: null,
    lifePhotos: [
      "https://readdy.ai/api/search-image?query=asian%20female%20therapist%20casual%20daily%20life%20portrait%20coffee%20shop%20natural%20light%20relaxed%20lifestyle%20warm%20smile&width=400&height=560&seq=lf_201&orientation=portrait",
    ],
    photos: [
      "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/4da58105-9f88-415f-a957-a7acb99f227e_02-.png?v=3e77774350a88cc7d3f737789eac33e6",
      "https://readdy.ai/api/search-image?query=professional%20female%20massage%20therapist%20spa%20uniform%20preparing%20for%20service%20warm%20clean%20background&width=400&height=560&seq=lf_202&orientation=portrait",
    ],
  },
  {
    id: 3,
    name: "\u738b\u96c5\u5a77",
    level: "\u9ad8\u7ea7" as const,
    levelStyle: { color: "#C8860A", bg: "#FFF8E7", border: "#FFD980" },
    status: "\u53ef\u670d\u52a1",
    statusStyle: { color: "#17B978", bg: "#E8FBF3" },
    rating: 5.0,
    orders: 2134,
    earliestTime: "20:00",
    distance: "0.86km",
    favorited: false,
    favorites: 512,
    specialties: ["\u7cbe\u6cb9SPA", "\u5b55\u671f\u8212\u7f13"],
    intro: "10\u5e74\u9ad8\u7aefSPA\u4ece\u4e1a\u7ecf\u9a8c\uff0c\u66fe\u5728\u4e94\u661f\u7ea7\u9152\u5e97\u62c5\u4efb\u9996\u5e2d\u6cbb\u7597\u5e08\uff0c\u4e13\u6ce8\u7cbe\u6cb9\u7597\u6cd5\u4e0e\u5b55\u671f\u62a4\u7406\u3002",
    location: "\u6df1\u5733\u5e02 \u00b7 86m",
    age: "88\u540e",
    years: "\u4ece\u4e1a10\u5e74",
    tags: ["\u8f7b\u67d4\u8212\u9002", "\u4e13\u4e1a\u8ba4\u8bc1", "\u670d\u52a1\u8d34\u5fc3", "\u975e\u5e38\u6ee1\u610f", "\u7f8e\u98df\u8fbe\u4eba"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/2bb23892-4ab4-4046-859b-26d10b96fdf4_03-.png?v=e343630d5858588c2a138f0bc16aed5d",
    video: "https://www.w3schools.com/html/movie.mp4",
    lifePhotos: [
      "https://readdy.ai/api/search-image?query=elegant%20asian%20senior%20female%20therapist%20outdoor%20garden%20natural%20light%20casual%20fashion%20portrait%20relaxed%20warm%20smile&width=400&height=560&seq=lf_301&orientation=portrait",
      "https://readdy.ai/api/search-image?query=asian%20woman%20lifestyle%20portrait%20park%20greenery%20natural%20light%20casual%20fashion%20summer%20warm%20smile%20candid&width=400&height=560&seq=lf_303&orientation=portrait",
    ],
    photos: [
      "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/2bb23892-4ab4-4046-859b-26d10b96fdf4_03-.png?v=e343630d5858588c2a138f0bc16aed5d",
      "https://readdy.ai/api/search-image?query=female%20spa%20therapist%20aromatherapy%20essential%20oil%20preparation%20professional%20indoor%20warm%20lighting&width=400&height=560&seq=lf_302&orientation=portrait",
    ],
  },
  {
    id: 4,
    name: "\u53ef\u4e50",
    level: "\u4e2d\u7ea7" as const,
    levelStyle: { color: "#8B6FE8", bg: "#F2EEFF", border: "#C9BCFF" },
    status: "\u53ef\u670d\u52a1",
    statusStyle: { color: "#17B978", bg: "#E8FBF3" },
    rating: 4.7,
    orders: 742,
    earliestTime: "14:00",
    distance: "3.22km",
    favorited: true,
    favorites: 188,
    specialties: ["\u8db3\u90e8\u7406\u7597", "\u5168\u8eab\u653e\u677e"],
    intro: "\u64c5\u957f\u6df1\u5c42\u7ec4\u7ec7\u6309\u6469\u4e0e\u8db3\u90e8\u53cd\u5c04\u7597\u6cd5\uff0c\u5e2e\u52a9\u90fd\u5e02\u767d\u9886\u5feb\u901f\u6062\u590d\u7cbe\u529b\uff0c\u6548\u679c\u7acb\u7aff\u89c1\u5f71\u3002",
    location: "\u6df1\u5733\u5e02 \u00b7 322m",
    age: "98\u540e",
    years: "\u4ece\u4e1a5\u5e74",
    tags: ["\u624b\u6cd5\u624e\u5b9e", "\u8ba4\u771f\u7ec6\u5fc3", "\u6548\u679c\u663e\u8457"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/f0921eaa-80cd-40ec-abd6-b69675e218b1_04-.png?v=37b523144e801a64b76184d4fc1e7a1c",
    video: null,
    lifePhotos: [
      "https://readdy.ai/api/search-image?query=young%20cheerful%20asian%20female%20daily%20life%20casual%20portrait%20city%20street%20natural%20light%20candid%20warm%20smile%20lifestyle&width=400&height=560&seq=lf_401&orientation=portrait",
    ],
    photos: [
      "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/f0921eaa-80cd-40ec-abd6-b69675e218b1_04-.png?v=37b523144e801a64b76184d4fc1e7a1c",
    ],
  },
  {
    id: 5,
    name: "\u674e\u68a6",
    level: "\u65b0\u4eba" as const,
    levelStyle: { color: "#FF7B22", bg: "#FFF3EC", border: "#FFD4B0" },
    status: "\u53ef\u670d\u52a1",
    statusStyle: { color: "#17B978", bg: "#E8FBF3" },
    rating: 4.9,
    orders: 1056,
    earliestTime: "17:30",
    distance: "1.05km",
    favorited: false,
    favorites: 143,
    specialties: ["\u7cbe\u6cb9SPA", "\u70ed\u77f3\u6309\u6469"],
    intro: "\u64c5\u957f\u7cbe\u6cb9\u7597\u6cd5\u4e0e\u70ed\u77f3\u6309\u6469\uff0c\u624b\u6cd5\u7ec6\u817b\uff0c\u670d\u52a1\u8d34\u5fc3\uff0c\u6df1\u53d7\u5ba2\u6237\u597d\u8bc4\u3002",
    location: "\u6df1\u5733\u5e02 \u00b7 105m",
    age: "00\u540e",
    years: "\u4ece\u4e1a3\u5e74",
    tags: ["\u6e29\u67d4\u4e13\u4e1a", "\u8d85\u51fa\u671f\u671b", "\u5f3a\u70c8\u63a8\u8350"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/294b3094-9f3c-4827-b444-c9cca4c86b36_05-.png?v=164634d148f4decfb7ce805ff7fea12a",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
    lifePhotos: [
      "https://readdy.ai/api/search-image?query=young%20asian%20female%20therapist%20new%20lifestyle%20portrait%20casual%20indoor%20clean%20background%20warm%20smile%20fresh%20natural%20light&width=400&height=560&seq=lf_501&orientation=portrait",
    ],
    photos: [
      "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/294b3094-9f3c-4827-b444-c9cca4c86b36_05-.png?v=164634d148f4decfb7ce805ff7fea12a",
    ],
  },
  {
    id: 6,
    name: "\u674e\u99a8",
    level: "\u4e2d\u7ea7" as const,
    levelStyle: { color: "#8B6FE8", bg: "#F2EEFF", border: "#C9BCFF" },
    status: "\u53ef\u670d\u52a1",
    statusStyle: { color: "#17B978", bg: "#E8FBF3" },
    rating: 4.8,
    orders: 623,
    earliestTime: "15:00",
    distance: "2.68km",
    favorited: false,
    favorites: 204,
    specialties: ["\u9888\u80a9\u653e\u677e", "\u8db3\u90e8\u7406\u7597"],
    intro: "\u4e13\u6ce8\u9888\u80a9\u8170\u80cc\u53ca\u8db3\u90e8\u7406\u7597\uff0c\u624b\u6cd5\u6e29\u548c\u7cbe\u51c6\uff0c\u5584\u4e8e\u6839\u636e\u5ba2\u6237\u9700\u6c42\u8c03\u6574\u529b\u5ea6\u3002",
    location: "\u6df1\u5733\u5e02 \u00b7 268m",
    age: "96\u540e",
    years: "\u4ece\u4e1a4\u5e74",
    tags: ["\u7269\u8d85\u6240\u503c", "\u670d\u52a1\u6001\u5ea6\u597d", "\u975e\u5e38\u6ee1\u610f"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/cdfcceaf-9d4f-480c-9f26-40f3ed91837e_06-.png?v=1185cd3fbe673a8b455525c0e7728589",
    video: null,
    lifePhotos: [
      "https://readdy.ai/api/search-image?query=asian%20female%20massage%20therapist%20lifestyle%20portrait%20indoor%20natural%20soft%20light%20comfortable%20relaxed%20candid%20warm%20smile&width=400&height=560&seq=lf_601&orientation=portrait",
    ],
    photos: [
      "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/cdfcceaf-9d4f-480c-9f26-40f3ed91837e_06-.png?v=1185cd3fbe673a8b455525c0e7728589",
    ],
  },
  {
    id: 7,
    name: "\u5218\u4f1a\u4f1a",
    level: "\u9ad8\u7ea7" as const,
    levelStyle: { color: "#C8860A", bg: "#FFF8E7", border: "#FFD980" },
    status: "\u53ef\u670d\u52a1",
    statusStyle: { color: "#17B978", bg: "#E8FBF3" },
    rating: 5.0,
    orders: 1876,
    earliestTime: "19:00",
    distance: "1.32km",
    favorited: true,
    favorites: 498,
    specialties: ["\u4e2d\u533b\u63a8\u62ff", "\u7ecf\u7edc\u758f\u901a"],
    intro: "9\u5e74\u6df1\u8015\u4e2d\u533b\u63a8\u62ff\u9886\u57df\uff0c\u53e4\u6cd5\u624b\u6cd5\u4f20\u627f\u4e0e\u73b0\u4ee3\u7406\u7597\u5b8c\u7f8e\u7ed3\u5408\uff0c\u670d\u52a1\u6b21\u6570\u8d851800\u5355\u3002",
    location: "\u6df1\u5733\u5e02 \u00b7 132m",
    age: "89\u540e",
    years: "\u4ece\u4e1a9\u5e74",
    tags: ["\u53e4\u6cd5\u63a8\u62ff", "\u624b\u6cd5\u4e00\u6d41", "\u53e3\u7891\u6781\u597d", "\u670d\u52a1\u6001\u5ea6\u597d"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/de001e1f-5c94-435a-ba99-27213131edf3_07-.png?v=3abff9dbf7ddb5551223697f18bf60af",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
    lifePhotos: [
      "https://readdy.ai/api/search-image?query=confident%20asian%20senior%20female%20therapist%20lifestyle%20outdoor%20nature%20park%20warm%20smile%20candid%20portrait%20natural%20light&width=400&height=560&seq=lf_701&orientation=portrait",
      "https://readdy.ai/api/search-image?query=asian%20woman%20lifestyle%20portrait%20outdoor%20city%20casual%20fashion%20warm%20afternoon%20natural%20light%20relaxed%20smile&width=400&height=560&seq=lf_703&orientation=portrait",
    ],
    photos: [
      "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/de001e1f-5c94-435a-ba99-27213131edf3_07-.png?v=3abff9dbf7ddb5551223697f18bf60af",
      "https://readdy.ai/api/search-image?query=professional%20chinese%20medicine%20therapist%20indoor%20traditional%20setting%20working%20herbal%20treatment%20lifestyle%20photo&width=400&height=560&seq=lf_702&orientation=portrait",
    ],
  },
];

export const therapists = [
  {
    id: 1,
    name: "\u6797\u6653\u8587",
    title: "\u9ad8\u7ea7\u6280\u5e08",
    experience: "8\u5e74\u7ecf\u9a8c",
    rating: 4.9,
    orders: 1280,
    specialty: ["\u5168\u8eab\u653e\u677e", "\u7cbe\u6cb9SPA", "\u4e2d\u533b\u63a8\u62ff"],
    tags: ["\u6e29\u67d4\u7ec6\u81f4", "\u624b\u6cd5\u4e13\u4e1a", "\u6c9f\u901a\u987a\u7545"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/78c805eb-2a27-46dc-9891-f2f0576571cc_01-3.png?v=29e49e33514a0eef7ddac149aca632b5",
    badge: "\u660e\u661f\u6280\u5e08",
    intro: "\u4e13\u4e1a\u56fd\u5bb6\u4e2d\u533b\u63a8\u62ff\u8d44\u683c\u8ba4\u8bc1\uff0c\u64c5\u957f\u8212\u7f13\u9888\u80a9\u8170\u80cc\u75db\u53ca\u5168\u8eab\u653e\u677e\uff0c8\u5e74\u4e30\u5bcc\u7ecf\u9a8c\u6df1\u53d7\u5ba2\u6237\u597d\u8bc4\u3002",
  },
  {
    id: 2,
    name: "\u4f55\u5029",
    title: "\u8d44\u6df1\u6280\u5e08",
    experience: "6\u5e74\u7ecf\u9a8c",
    rating: 4.8,
    orders: 986,
    specialty: ["\u4e2d\u533b\u63a8\u62ff", "\u9888\u80a9\u653e\u677e", "\u8db3\u90e8\u7406\u7597"],
    tags: ["\u529b\u9053\u7cbe\u51c6", "\u8010\u5fc3\u8d1f\u8d23", "\u51c6\u65f6\u5b88\u7ea6"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/4da58105-9f88-415f-a957-a7acb99f227e_02-.png?v=3e77774350a88cc7d3f737789eac33e6",
    badge: "\u53e3\u7891\u4e4b\u661f",
    intro: "\u6bd5\u4e1a\u4e8e\u4e2d\u533b\u836f\u5927\u5b66\uff0c\u6301\u6709\u591a\u9879\u4e13\u4e1a\u8bc1\u4e66\uff0c\u64c5\u957f\u8fd0\u7528\u4f20\u7edf\u63a8\u62ff\u624b\u6cd5\u7ed3\u5408\u73b0\u4ee3\u7406\u7597\u6280\u672f\u3002",
  },
  {
    id: 3,
    name: "\u738b\u96c5\u5a77",
    title: "\u9996\u5e2d\u6280\u5e08",
    experience: "10\u5e74\u7ecf\u9a8c",
    rating: 5.0,
    orders: 2134,
    specialty: ["\u7cbe\u6cb9SPA", "\u5b55\u671f\u8212\u7f13", "\u5168\u8eab\u653e\u677e"],
    tags: ["\u8f7b\u67d4\u8212\u9002", "\u4e13\u4e1a\u8ba4\u8bc1", "\u670d\u52a1\u8d34\u5fc3"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/2bb23892-4ab4-4046-859b-26d10b96fdf4_03-.png?v=e343630d5858588c2a138f0bc16aed5d",
    badge: "\u9996\u5e2d\u6280\u5e08",
    intro: "10\u5e74\u9ad8\u7aefSPA\u4ece\u4e1a\u7ecf\u9a8c\uff0c\u66fe\u5728\u4e94\u661f\u7ea7\u9152\u5e97\u62c5\u4efb\u9996\u5e2d\u6cbb\u7597\u5e08\uff0c\u4e13\u6ce8\u7cbe\u6cb9\u7597\u6cd5\u4e0e\u5b55\u671f\u62a4\u7406\u3002",
  },
  {
    id: 4,
    name: "\u53ef\u4e50",
    title: "\u9ad8\u7ea7\u6280\u5e08",
    experience: "5\u5e74\u7ecf\u9a8c",
    rating: 4.7,
    orders: 742,
    specialty: ["\u8db3\u90e8\u7406\u7597", "\u5168\u8eab\u653e\u677e", "\u9888\u80a9\u653e\u677e"],
    tags: ["\u624b\u6cd5\u624e\u5b9e", "\u8ba4\u771f\u7ec6\u5fc3", "\u6548\u679c\u663e\u8457"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/f0921eaa-80cd-40ec-abd6-b69675e218b1_04-.png?v=37b523144e801a64b76184d4fc1e7a1c",
    badge: "",
    intro: "\u64c5\u957f\u6df1\u5c42\u7ec4\u7ec7\u6309\u6469\u4e0e\u8db3\u90e8\u53cd\u5c04\u7597\u6cd5\uff0c\u5e2e\u52a9\u90fd\u5e02\u767d\u9886\u5feb\u901f\u6062\u590d\u7cbe\u529b\uff0c\u6548\u679c\u7acb\u7aff\u89c1\u5f71\u3002",
  },
  {
    id: 5,
    name: "\u674e\u68a6",
    title: "\u9ad8\u7ea7\u6280\u5e08",
    experience: "7\u5e74\u7ecf\u9a8c",
    rating: 4.9,
    orders: 1056,
    specialty: ["\u7cbe\u6cb9SPA", "\u5168\u8eab\u653e\u677e", "\u70ed\u77f3\u6309\u6469"],
    tags: ["\u6e29\u67d4\u4e13\u4e1a", "\u8d85\u51fa\u671f\u671b", "\u5f3a\u70c8\u63a8\u8350"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/294b3094-9f3c-4827-b444-c9cca4c86b36_05-.png?v=164634d148f4decfb7ce805ff7fea12a",
    badge: "\u65b0\u4eba\u4e4b\u661f",
    intro: "\u64c5\u957f\u7cbe\u6cb9\u7597\u6cd5\u4e0e\u70ed\u77f3\u6309\u6469\uff0c\u624b\u6cd5\u7ec6\u817b\uff0c\u670d\u52a1\u8d34\u5fc3\uff0c\u6df1\u53d7\u5ba2\u6237\u597d\u8bc4\u3002",
  },
  {
    id: 6,
    name: "\u674e\u99a8",
    title: "\u8d44\u6df1\u6280\u5e08",
    experience: "4\u5e74\u7ecf\u9a8c",
    rating: 4.8,
    orders: 623,
    specialty: ["\u9888\u80a9\u653e\u677e", "\u8db3\u90e8\u7406\u7597", "\u5b55\u671f\u8212\u7f13"],
    tags: ["\u7269\u8d85\u6240\u503c", "\u670d\u52a1\u6001\u5ea6\u597d", "\u975e\u5e38\u6ee1\u610f"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/cdfcceaf-9d4f-480c-9f26-40f3ed91837e_06-.png?v=1185cd3fbe673a8b455525c0e7728589",
    badge: "",
    intro: "\u4e13\u6ce8\u9888\u80a9\u8170\u80cc\u53ca\u8db3\u90e8\u7406\u7597\uff0c\u624b\u6cd5\u6e29\u548c\u7cbe\u51c6\uff0c\u5584\u4e8e\u6839\u636e\u5ba2\u6237\u9700\u6c42\u8c03\u6574\u529b\u5ea6\u3002",
  },
  {
    id: 7,
    name: "\u5218\u4f1a\u4f1a",
    title: "\u9996\u5e2d\u6280\u5e08",
    experience: "9\u5e74\u7ecf\u9a8c",
    rating: 5.0,
    orders: 1876,
    specialty: ["\u4e2d\u533b\u63a8\u62ff", "\u5168\u8eab\u653e\u677e", "\u7ecf\u7edc\u758f\u901a"],
    tags: ["\u53e4\u6cd5\u63a8\u62ff", "\u624b\u6cd5\u4e00\u6d41", "\u53e3\u7891\u6781\u597d"],
    avatar: "https://storage.readdy-site.link/project_files/9ab11e4a-1ad0-44a1-ad98-ece3323c70e1/de001e1f-5c94-435a-ba99-27213131edf3_07-.png?v=3abff9dbf7ddb5551223697f18bf60af",
    badge: "\u4eba\u6c14No.1",
    intro: "9\u5e74\u6df1\u8015\u4e2d\u533b\u63a8\u62ff\u9886\u57df\uff0c\u53e4\u6cd5\u624b\u6cd5\u4f20\u627f\u4e0e\u73b0\u4ee3\u7406\u7597\u5b8c\u7f8e\u7ed3\u5408\uff0c\u670d\u52a1\u6b21\u6570\u8d851800\u5355\u3002",
  },
];

export const reviews = [
  {
    id: 1,
    user: "\u8d75**",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20woman%20casual%20portrait%20avatar%2C%20simple%20background%2C%20friendly%20expression&width=80&height=80&seq=u001&orientation=squarish",
    rating: 5,
    date: "2026-04-10",
    service: "\u5168\u8eab\u653e\u677e \u00b7 \u6797\u6653\u8587\u6280\u5e08",
    content: "\u4f53\u9a8c\u8d85\u68d2\uff01\u6280\u5e08\u624b\u6cd5\u975e\u5e38\u4e13\u4e1a\uff0c\u529b\u5ea6\u521a\u521a\u597d\u3002\u9884\u7ea6\u4e5f\u5f88\u65b9\u4fbf\uff0c\u51c6\u65f6\u4e0a\u95e8\uff0c\u6574\u4e2a\u8fc7\u7a0b\u5f88\u653e\u677e\u3002\u5f3a\u70c8\u63a8\u8350\uff01",
    images: ["https://readdy.ai/api/search-image?query=relaxing%20massage%20review%20photo%2C%20comfortable%20home%20setting%2C%20warm%20lighting&width=160&height=160&seq=r001&orientation=squarish"],
    likes: 42,
    tags: ["\u4e13\u4e1a\u6280\u672f", "\u51c6\u65f6\u4e0a\u95e8", "\u6548\u679c\u663e\u8457"],
  },
  {
    id: 2,
    user: "\u674e**",
    avatar: "https://readdy.ai/api/search-image?query=middle%20aged%20asian%20man%20casual%20portrait%20avatar%2C%20simple%20background&width=80&height=80&seq=u002&orientation=squarish",
    rating: 5,
    date: "2026-04-08",
    service: "\u4e2d\u533b\u63a8\u62ff \u00b7 \u9648\u5fd7\u8fdc\u6280\u5e08",
    content: "\u9888\u690e\u95ee\u9898\u56f0\u6270\u6211\u597d\u4e45\u4e86\uff0c\u8fd9\u6b21\u8bd5\u4e86\u4e2d\u533b\u63a8\u62ff\uff0c\u5f53\u5929\u5c31\u611f\u89c9\u8f7b\u677e\u4e86\u5f88\u591a\u3002\u6280\u5e08\u975e\u5e38\u6709\u8010\u5fc3\uff0c\u8fd8\u7ed9\u6211\u8bb2\u89e3\u4e86\u65e5\u5e38\u4fdd\u517b\u65b9\u6cd5\u3002",
    images: [],
    likes: 38,
    tags: ["\u4e13\u4e1a\u8ba4\u8bc1", "\u8010\u5fc3\u89e3\u7b54", "\u6548\u679c\u597d"],
  },
  {
    id: 3,
    user: "\u5b59**",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20woman%20portrait%20avatar%2C%20clean%20background%2C%20warm%20smile&width=80&height=80&seq=u003&orientation=squarish",
    rating: 5,
    date: "2026-04-05",
    service: "\u7cbe\u6cb9SPA \u00b7 \u738b\u96c5\u5a77\u6280\u5e08",
    content: "\u738b\u8001\u5e08\u592a\u5389\u5bb3\u4e86\uff01\u7cbe\u6cb9\u7684\u9999\u6c14\u914d\u4e0a\u4e13\u4e1a\u7684\u624b\u6cd5\uff0c\u6574\u4e2a\u4eba\u90fd\u98d8\u4e86\u3002\u73af\u5883\u5e03\u7f6e\u4e5f\u5f88\u7528\u5fc3\uff0c\u4e0b\u6b21\u8fd8\u8981\u9884\u7ea6\uff01",
    images: [
      "https://readdy.ai/api/search-image?query=aromatherapy%20spa%20review%20photo%2C%20essential%20oils%20candles%20setting&width=160&height=160&seq=r002&orientation=squarish",
      "https://readdy.ai/api/search-image?query=luxury%20home%20spa%20treatment%20photo%2C%20warm%20cozy%20atmosphere&width=160&height=160&seq=r003&orientation=squarish",
    ],
    likes: 67,
    tags: ["\u9999\u85b0\u653e\u677e", "\u6280\u672f\u4e00\u6d41", "\u4f1a\u518d\u6765"],
  },
  {
    id: 4,
    user: "\u5468**",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20man%20casual%20selfie%20avatar%2C%20clean%20background&width=80&height=80&seq=u004&orientation=squarish",
    rating: 4,
    date: "2026-04-03",
    service: "\u8db3\u90e8\u7406\u7597 \u00b7 \u5f20\u4f1f\u5cf0\u6280\u5e08",
    content: "\u8db3\u90e8\u6309\u6469\u505a\u5b8c\u7761\u7720\u597d\u591a\u4e86\uff0c\u6280\u5e08\u624b\u6cd5\u4e0d\u9519\uff0c\u4e0b\u6b21\u518d\u6765\u3002\u5c31\u662f\u9884\u7ea6\u65f6\u95f4\u7a0d\u5fae\u7b49\u4e86\u4e00\u4e0b\uff0c\u5e0c\u671b\u53ef\u4ee5\u5feb\u4e00\u70b9\u3002",
    images: [],
    likes: 19,
    tags: ["\u6539\u5584\u7761\u7720", "\u624b\u6cd5\u4e13\u4e1a"],
  },
  {
    id: 5,
    user: "\u5434**",
    avatar: "https://readdy.ai/api/search-image?query=mature%20asian%20woman%20portrait%20avatar%2C%20simple%20clean%20background&width=80&height=80&seq=u005&orientation=squarish",
    rating: 5,
    date: "2026-03-29",
    service: "\u5b55\u671f\u8212\u7f13 \u00b7 \u738b\u96c5\u5a77\u6280\u5e08",
    content: "\u5b55\u671f\u8170\u80cc\u5f88\u4e0d\u8212\u670d\uff0c\u670b\u53cb\u63a8\u8350\u4e86\u8fd9\u5bb6\u3002\u738b\u8001\u5e08\u975e\u5e38\u4e13\u4e1a\uff0c\u4e86\u89e3\u4e86\u6211\u7684\u60c5\u51b5\u4e4b\u540e\u505a\u4e86\u9488\u5bf9\u6027\u7684\u624b\u6cd5\uff0c\u5f88\u5b89\u5fc3\uff0c\u6548\u679c\u5f88\u597d\uff01",
    images: [],
    likes: 54,
    tags: ["\u4e13\u4e1a\u8d34\u5fc3", "\u5b55\u671f\u4e13\u5c5e", "\u5b89\u5168\u653e\u5fc3"],
  },
];

export const promotions = [
  {
    id: 1,
    title: "\u65b0\u5ba2\u9996\u5355\u7acb\u51cf60\u5143",
    subtitle: "\u4ec5\u9650\u65b0\u6ce8\u518c\u7528\u6237\uff0c\u4eca\u65e5\u53ef\u7528",
    color: "from-amber-500 to-orange-400",
    icon: "ri-gift-line",
    badge: "\u65b0\u5ba2\u4e13\u4eab",
  },
  {
    id: 2,
    title: "\u5468\u4e09\u4f1a\u5458\u65e5 \u00b7 \u5168\u573697\u6298",
    subtitle: "\u6bcf\u5468\u4e09\u4f1a\u5458\u4e13\u4eab\u6298\u6263",
    color: "from-rose-500 to-pink-400",
    icon: "ri-vip-crown-line",
    badge: "\u4f1a\u5458\u4e13\u5c5e",
  },
  {
    id: 3,
    title: "\u62993\u90001 \u00b7 \u5957\u9910\u8d85\u503c\u7ec4\u5408",
    subtitle: "\u8d2d\u4e703\u6b21\u670d\u52a1\u8d60\u90011\u6b21\u8db3\u7597",
    color: "from-teal-500 to-emerald-400",
    icon: "ri-coupon-line",
    badge: "\u9650\u65f6\u6d3b\u52a8",
  },
];

export const serviceList = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=professional%20foot%20massage%20reflexology%20therapy%20spa%20treatment%20wooden%20tools%20warm%20water%20basin%20clean%20towels%20natural%20light%20cozy%20setting&width=300&height=300&seq=sl001&orientation=squarish",
    name: "\u65e5\u5f0f\u8db3\u7597120\u5206\u949f+\u81f3\u5c0a\u81ea\u52a9\u9910",
    meta: "120\u5206\u949f \u00b7 \u8db3\u90e8 \u00b7 \u8336\u6c34\u9910\u996e",
    tags: ["\u8d85\u503c\u7279\u60e0", "\u653e\u677e\u89e3\u538b"],
    count: "1.2\u4e07\u4eba\u9009\u62e9",
    price: 498,
    isMember: true,
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=hot%20stone%20back%20massage%20therapy%20professional%20spa%20treatment%20warm%20stones%20spine%20relaxation%20clean%20white%20linen%20soft%20lighting&width=300&height=300&seq=sl002&orientation=squarish",
    name: "\u5168\u8eab\u70ed\u77f3SPA\u6309\u6469907\u5206\u949f\u5957\u9910",
    meta: "90\u5206\u949f \u00b7 \u5168\u8eab \u00b7 \u7cbe\u6cb9\u70ed\u77f3",
    tags: ["\u65b0\u5ba2\u9996\u9009", "\u6df1\u5ea6\u653e\u677e"],
    count: "8600\u4eba\u9009\u62e9",
    price: 368,
    isMember: true,
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=traditional%20chinese%20tuina%20massage%20neck%20shoulder%20therapy%20professional%20hands%20acupressure%20warm%20clinic%20wooden%20background&width=300&height=300&seq=sl003&orientation=squarish",
    name: "\u9888\u80a9\u8170\u80cc\u4e2d\u533b\u63a8\u62ff607\u5206\u949f\u7406\u7597",
    meta: "60\u5206\u949f \u00b7 \u9888\u80a9\u8170\u80cc \u00b7 \u4f20\u7edf\u624b\u6cd5",
    tags: ["\u7ecf\u5178\u70ed\u9500", "\u9888\u690e\u5fc5\u5907"],
    count: "2.1\u4e07\u4eba\u9009\u62e9",
    price: 188,
    isMember: true,
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=aromatherapy%20essential%20oil%20full%20body%20massage%20luxury%20spa%20rose%20petals%20candles%20white%20linen%20elegant%20treatment%20room&width=300&height=300&seq=sl004&orientation=squarish",
    name: "\u7cbe\u6cb9\u9999\u85b0\u5168\u8eabSPA120\u5206\u949f",
    meta: "120\u5206\u949f \u00b7 \u5168\u8eab \u00b7 \u8fdb\u53e3\u7cbe\u6cb9",
    tags: ["\u5973\u751f\u6700\u7231", "\u7f8e\u808c\u7109\u989c"],
    count: "1.5\u4e07\u4eba\u9009\u62e9",
    price: 428,
    isMember: true,
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=head%20scalp%20massage%20therapy%20relaxation%20professional%20care%20clean%20bright%20salon%20setting%20natural%20light%20fresh&width=300&height=300&seq=sl005&orientation=squarish",
    name: "\u5934\u90e8\u80a9\u9888\u8212\u538b\u6309\u6469457\u5206\u949f",
    meta: "45\u5206\u949f \u00b7 \u5934\u90e8\u80a9\u9888 \u00b7 \u8212\u538b\u653e\u677e",
    tags: ["\u4e0a\u73ed\u65cf\u5fc5\u5907", "\u5feb\u901f\u51cf\u538b"],
    count: "9800\u4eba\u9009\u62e9",
    price: 138,
    isMember: true,
  },
];

export const userOrders = [
  {
    id: "ORD20260412001",
    service: "\u5168\u8eab\u653e\u677e",
    therapist: "\u6797\u6653\u8587",
    date: "2026-04-12",
    time: "14:00",
    duration: "90min",
    price: 298,
    status: "completed",
    statusText: "\u5df2\u5b8c\u6210",
  },
  {
    id: "ORD20260415001",
    service: "\u7cbe\u6cb9SPA",
    therapist: "\u738b\u96c5\u5a77",
    date: "2026-04-15",
    time: "16:00",
    duration: "120min",
    price: 398,
    status: "upcoming",
    statusText: "\u5f85\u670d\u52a1",
  },
  {
    id: "ORD20260401001",
    service: "\u4e2d\u533b\u63a8\u62ff",
    therapist: "\u9648\u5fd7\u8fdc",
    date: "2026-04-01",
    time: "10:00",
    duration: "60min",
    price: 188,
    status: "completed",
    statusText: "\u5df2\u5b8c\u6210",
  },
];
